import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';

const MASCOT_URL = 'https://d2zdlj1ifv8u1d.cloudfront.net/images/mascot.png';

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: '20px',
    padding: '28px 22px 24px',
    maxWidth: '400px',
    width: '100%',
    boxSizing: 'border-box',
    position: 'relative',
    textAlign: 'center',
    backgroundColor: '#337D36',
    color: '#FFFFFF',
    border: '1px solid #2A682C',
    boxShadow: '0 8px 28px rgba(0, 0, 0, 0.35)',
  },
  closeButton: {
    position: 'absolute',
    top: '8px',
    right: '8px',
    color: '#FFFFFF',
    padding: '8px',
    '& .MuiSvgIcon-root': {
      color: '#FFFFFF',
      fill: '#FFFFFF',
    },
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.12)',
    },
  },
  mascotWrap: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '18px',
    marginTop: '8px',
  },
  mascotCircle: {
    width: '100px',
    height: '100px',
    borderRadius: '50%',
    overflow: 'hidden',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    },
  },
  headline: {
    fontWeight: 700,
    fontSize: '1.35rem',
    color: '#FFFFFF',
    marginBottom: '12px',
    lineHeight: 1.3,
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.15rem',
    },
  },
  subtext: {
    fontSize: '0.98rem',
    color: 'rgba(255, 255, 255, 0.92)',
    lineHeight: 1.45,
    marginBottom: '22px',
    padding: '0 4px',
  },
  ctaButton: {
    width: '100%',
    backgroundColor: '#89E683',
    color: '#1A1A1A',
    fontWeight: 700,
    textTransform: 'none',
    borderRadius: '10px',
    padding: '14px 16px',
    fontSize: '1.05rem',
    '&:hover': {
      backgroundColor: '#7BDA75',
    },
  },
}));

/**
 * Modal na home quando o cliente ainda não cadastrou e-mail real (conta rápida).
 */
export default function CompleteProfileEmailModal({
  open,
  onClose,
  onEditProfile,
}) {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ className: classes.paper }}
      aria-labelledby="complete-profile-email-title"
    >
      <IconButton
        className={classes.closeButton}
        aria-label="Fechar"
        onClick={onClose}
        size="small"
      >
        <CloseIcon />
      </IconButton>
      <div className={classes.mascotWrap}>
        <div className={classes.mascotCircle}>
          <img src={MASCOT_URL} alt="" />
        </div>
      </div>
      <Typography id="complete-profile-email-title" component="h2" className={classes.headline}>
        Falta pouco para completar seu perfil!
      </Typography>
      <Typography component="p" className={classes.subtext}>
        Finalize suas informações em poucos passos.
      </Typography>
      <Button
        type="button"
        variant="contained"
        className={classes.ctaButton}
        disableElevation
        onClick={onEditProfile}
      >
        Editar perfil
      </Button>
    </Dialog>
  );
}
